/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class PermissionReplyAdd extends Component {
  @service
  session;

  @service
  store;

  @service
  toaster;

  event = null;
  learner = null;
  @tracked
  permissionReply = null;
  refresh() {}
  @tracked
  dialogOpen = false;

  init() {
    super.init(...arguments);
  }

  loadPermissionReply() {
    return this.store
      .query('events/permission-reply', {
        schoolId: this.event.school.get('id'),
        eventId: this.event.id,
        personId: this.learner.id,
      })
      .then(async (replies) => {
        if (replies.length) {
          // This is a bit weird - but if this component finds an existing permission,
          // it will hit refresh the list on the containing component,
          // which will cause this component to be de-rendered,
          // essentially killing itself
          this.refresh();
        } else {
          this.permissionReply = this.store.createRecord(
            'events/permission-reply',
            {
              // A belongsTo takes a record, not the async proxy.
              school: await this.event.school,
              event: this.event,
              person: this.learner,
              author: this.get('session.person'),
            },
          );
          // Copy the learner value of each permission field as the default.
          this.event.permissionFields.forEach((field) => {
            const existingField = this.learner.field(field.key);
            if (existingField) {
              this.permissionReply.setFieldValue(
                field.key,
                existingField.value,
                existingField.datatype,
              );
            }
          });
        }
      });
  }

  @action
  openDialog() {
    this.loadPermissionReply().then(() => {
      this.dialogOpen = true;
    });
  }

  @action
  save() {
    this.permissionReply
      .save()
      .then(() => {
        this.refresh();
        this.toaster.success('Permissions saved successfully!');
      })
      .catch(() => {
        this.toaster.error('Permission save failed!');
      })
      .finally(() => {
        this.dialogOpen = false;
      });
  }
}
